dmx.Component('bootbox', {

    methods: {
        alert: function(options) {
            bootbox.alert(options);
        }
    }

});